import { type InertiaLinkProps, Link } from "@inertiajs/react";

import {
  BUTTON_BASE_CLASSES,
  BUTTON_VARIANT_CLASSES,
  type Variant,
} from "./Button";

type LinkButtonProps = InertiaLinkProps & {
  variant?: Variant;
};

// Same look as Button, for navigation (e.g. "Cancelar") instead of form submission.
export default function LinkButton({
  variant = "secondary",
  className = "",
  children,
  ...props
}: LinkButtonProps) {
  return (
    <Link
      className={`${BUTTON_BASE_CLASSES} ${BUTTON_VARIANT_CLASSES[variant]} ${className}`}
      {...props}
    >
      {children}
    </Link>
  );
}
